<script lang="ts">
export default {
  name: 'KkSettingKeywordModal',
}
</script>
<script setup lang="ts">
import { computed, ref } from 'vue'
import { KkModal, KkButton, KkBox, KkRadioGroup, KkLoading } from '../../../../components/base'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

interface Props {
  isVisible: boolean,
  selectedTag: string,
  loading: boolean
}
const props = withDefaults(defineProps<Props>(), {
  isVisible: false,
  selectedTag: '',
  loading: false
})

interface Emits {
  (e: 'close'): void
  (e: 'specify', value: string): void
  (e: 'ignore', value: string): void
}
const emit = defineEmits<Emits>()

const settingKeyword = ref<string>('specify')

const settingKeywordOptions = computed(() => {
  return [
    {
      id: 'specify',
      value: 'specify',
      text: t('pages.CompaniesReviews.SettingKeywordModal.specifyWord'),
    },
    {
      id: 'ignore',
      value: 'ignore',
      text: t('pages.CompaniesReviews.SettingKeywordModal.ignoreWord'),
    },
  ]
})

const changeSettingKeyword = (value: typeof settingKeywordOptions.value[number]['value']): void => {
  settingKeyword.value = value
}

const saveSetting = (): void => {
  switch (settingKeyword.value) {
  case 'specify':
    emit('specify', props.selectedTag)
    break
  case 'ignore':
    emit('ignore', props.selectedTag)
    break
  }
}
</script>
<template>
  <KkModal class="settingKeyword" width="720px" :is-visible="props.isVisible" @change="emit('close')">
    <KkBox :title="t('pages.CompaniesReviews.SettingKeywordModal.title')">
      <template #content>
        <KkLoading v-if="loading" />
        <div v-else class="settingKeyword__content">
          <span class="settingKeyword__selected">{{ $t('pages.CompaniesReviews.SettingKeywordModal.setWord') }}: {{ selectedTag }}</span>
          <KkRadioGroup
            :model-value="settingKeyword"
            :items="settingKeywordOptions"
            name="settingKeyword"
            @update:model-value="changeSettingKeyword"
          />
        </div>
      </template>
      <template #footer>
        <div class="c-button c-button--right">
          <KkButton
            class="button"
            color="secondary"
            :text="t('labels.cancel')"
            @click="emit('close')"
          />
          <KkButton
            class="button"
            color="primary"
            :text="t('labels.save')"
            :disabled="loading"
            @click="saveSetting"
          />
        </div>
      </template>
    </KkBox>
  </KkModal>
</template>
<style lang="scss" scoped>
.settingKeyword {
  &__selected {
    font-weight: bold;
  }
  &__content {
    height: 120px;
  }
}
.button {
  margin-left: 8px;
}
</style>
